export default __webpack_public_path__ + "static/media/img2.d4411e4e.png";